import { fetchActiveInfo } from "@Services/api";
import { Modal } from "@t8891/pc-v1";
import React from "react";
import { useQuery } from "react-query";
import AskPrice from "./AskPrice";
import Cookie from "js-cookie";
import styles from "./AskPriceModal.module.less";

const AskPriceModal: React.FC<any> = ({
    visible,
    setVisible,
    kindId,
    brandId,
    type,
}) => {
    const { data } = useQuery(
        `fetchActiveInfo`,
        async () => {
            const res = await fetchActiveInfo({ name: "buying-party" });
            if (res?.status === 12000) {
                return res.data;
            }
        },
        { initialData: { inquiry: {} } }
    );

    if (!visible) return null;

    return (
        <section className={styles["ask-model"]}>
            <button
                aria-label="Close"
                className={styles["modal-close"]}
                onClick={() => {
                    Cookie.set("isArticleInquiry", "1", { expires: 7200 });
                    setVisible(false);
                }}
            ></button>
            <AskPrice
                activityStatus={data.activityStatus}
                brandId={brandId}
                setVisible={setVisible}
                kindId={kindId}
                type={type}
            />
        </section>
    );
};
export default AskPriceModal;
